import { css } from "@compiled/react";
import { FormattedMessage } from "react-intl";

import { media } from "@atlaskit/primitives";

import { NavigationCard, NavigationCardProps } from "./navigation-cards";

export type AgileCardsProps = {
    headerText: string;
    cardsProps: NavigationCardProps[];
};

export const AgileCards = ({ headerText, cardsProps }: AgileCardsProps) => {
    const containerCSS = css({
        "display": "flex",
        "flexWrap": "wrap",
        "marginInlineStart": "-16px",
        "marginInlineEnd": "-16px",
        "paddingBlockStart": "16px",
        "paddingBlockEnd": "16px",
        "color": "#253858",

        // FIXME: These nested selectors are hacks to force the NavigationCard component to look like an Agile card
        /* eslint-disable @atlaskit/ui-styling-standard/no-nested-selectors */
        ".contentBlock-eyebrow": {
            color: "#42526E",
            fontSize: "12px",
            fontWeight: "400 !important",
            lineHeight: "24px",
            textTransform: "uppercase",
            letterSpacing: "1px",
            fontFamily: "var(--bxp-charlie-display-font-family)"
        },
        "h3": {
            color: "#253858"
        },
        "img": {
            borderRadius: "4px 4px 0px 0px"
        },
        ".text-section": {
            height: "100%"
        },
        ".link-wrapper": {
            alignSelf: "end"
        },
        ".contentBlock-linkFlex": {
            height: "100%",
            margin: "0"
        }
        /* eslint-enable @atlaskit/ui-styling-standard/no-nested-selectors */
    });

    const headerCSS = css({
        color: "#253858",
        fontSize: "1.5rem",
        lineHeight: "1.3333333",
        marginBlockEnd: "16px",
        marginBlockStart: "0px",
        letterSpacing: "0.3px",
        fontWeight: "500"
    });

    const cardCSS = css({
        "width": "33.33%",
        "flexBasis": "33.33%",
        "padding": "16px",

        // FIXME: These nested selectors are hacks to force the NavigationCard component to look like an Agile card
        /* eslint-disable @atlaskit/ui-styling-standard/no-nested-selectors */
        ".navigation-card": {
            borderRadius: "4px",
            boxShadow: "1px 2px 2px 2px rgba(0,0,0,.08)"
        },
        /* eslint-enable @atlaskit/ui-styling-standard/no-nested-selectors */

        [media.only.sm]: {
            width: "50%",
            flexBasis: "50%"
        },
        [media.below.sm]: {
            width: "100%",
            flexBasis: "100%"
        }
    });

    return (
        <div css={css({ padding: "16px 16px 16px 0px" })}>
            <h3 css={headerCSS}>
                <FormattedMessage
                    id="AgileOverview.AgileCards.Card.Header"
                    defaultMessage="{headerText} featured content"
                    values={{ headerText }}
                    description="headerText is an agile concept such as Kanban, Agile project management, Design, etc."
                />
            </h3>

            <div css={containerCSS}>
                {cardsProps.map((props) => {
                    return (
                        <div
                            css={cardCSS}
                            key={`${props.headerText}-body-card-container`}
                        >
                            <NavigationCard
                                {...props}
                                key={`${props.headerText}-body-card`}
                            />
                        </div>
                    );
                })}
            </div>
        </div>
    );
};
